module.exports = __webpack_public_path__ + "static/media/AppStore.fe587064.svg";